export default __webpack_public_path__ + "static/media/gray.d50138c0.svg";